import React, { useEffect, useState } from 'react';
import { Alert, Card, Spin, Table, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { api } from '../../services/api';

const getSituacao = (subscriptionStatus) => {
  const normalized = (subscriptionStatus || '').toString().toUpperCase();

  if (normalized === 'ACTIVE') {
    return { label: 'Ativo', color: 'green' };
  }

  if (normalized === 'TRIAL' || normalized === 'TRIALING') {
    return { label: 'Trial', color: 'blue' };
  }

  return { label: 'Sem assinatura', color: 'default' };
};

const formatTrial = (trialEndsAt) => {
  if (!trialEndsAt) {
    return '-';
  }

  const date = new Date(trialEndsAt);
  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  return date.toLocaleDateString('pt-BR');
};

const PlatformTenantsList = ({ refreshKey = 0 }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [tenants, setTenants] = useState([]);

  useEffect(() => {
    const loadTenants = async () => {
      setLoading(true);
      setError('');

      try {
        const response = await api.get('/api/platform-admin/tenants');
        const rows = Array.isArray(response.data) ? response.data : [];
        setTenants(rows);
      } catch (requestError) {
        console.error(requestError);
        setError('Nao foi possivel carregar a lista de tenants.');
      } finally {
        setLoading(false);
      }
    };

    loadTenants();
  }, [refreshKey]);

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      render: (value) => value || '-',
    },
    {
      title: 'Cadastro',
      dataIndex: 'public_signup_enabled',
      key: 'public_signup_enabled',
      render: (value) => (
        <Tag color={value ? 'green' : 'default'}>{value ? 'Publico' : 'Privado'}</Tag>
      ),
    },
    {
      title: 'Plano',
      dataIndex: 'plan_code',
      key: 'plan_code',
      render: (value) => value || '-',
    },
    {
      title: 'Status',
      dataIndex: 'subscription_status',
      key: 'subscription_status',
      render: (value) => value || '-',
    },
    {
      title: 'Trial',
      dataIndex: 'trial_ends_at',
      key: 'trial_ends_at',
      render: (value) => formatTrial(value),
    },
    {
      title: 'Situacao',
      key: 'situacao',
      render: (_, record) => {
        const situacao = getSituacao(record.subscription_status);
        return <Tag color={situacao.color}>{situacao.label}</Tag>;
      },
    },
  ];

  return (
    <Card title="Tenants" style={{ marginTop: 24 }}>
      {error ? (
        <Alert
          type="error"
          showIcon
          message="Erro ao carregar tenants"
          description={error}
          style={{ marginBottom: 16 }}
        />
      ) : null}

      {loading ? (
        <div style={{ minHeight: 180, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Spin tip="Carregando tenants..." />
        </div>
      ) : (
        <Table
          rowKey={(record) => record.id}
          dataSource={tenants}
          columns={columns}
          pagination={{ pageSize: 10 }}
          onRow={(record) => ({
            onClick: () => navigate(`/platform/tenant/${record.id}`),
            style: { cursor: 'pointer' },
          })}
        />
      )}
    </Card>
  );
};

export default PlatformTenantsList;
